module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.dialogs), function(item) {
    return [_c('v-dialog', {
      attrs: {
        "contentClass": item.fullscreen && 'v-modal-factory-fullscreen',
        "max-width": "600px",
        "persistent": ""
      },
      model: {
        value: (item.show),
        callback: function($$v) {
          _vm.$set(item, "show", $$v)
        },
        expression: "item.show"
      }
    }, [_c(item.comp, {
      tag: "component",
      on: {
        "close": function($event) {
          return _vm.close(item.id)
        }
      }
    })], 1)]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a877419","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ModalFactory.vue
// module id = 978
// module chunks = 1